<template>
  <div>
    <el-progress
      :class="uploadFlag ? 'show' : ''"
      :width="120"
      :percentage="uploadPercentage"
      status="success"
      class="process"
    ></el-progress>
    <el-upload
      class="pc-upload-file"
      accept=".xls,.xlsx,.doc,.docx,.pdf,.ppt,.pptx"
      action
      :one-third="false"
      :auto-upload="true"
      :show-file-list="false"
      :beforeUpload="beforeUpload"
      :http-request="uploadFile"
    >
      <el-button size="small" type="primary">添加新{{ title }}</el-button>
      <div slot="tip" class="el-upload__tip">上传文件不可大于5M</div>
    </el-upload>
  </div>
</template>

<script>
import { getOSSAuthFile_Api } from "@/apis/oss.api";
export default {
  data() {
    return {
      uploadPercentage: 0,
      file_url: null,
      uploadFlag: false,
    };
  },
  props: ["file", "title"],
  methods: {
    beforeUpload(file) {
      console.log("file", file);
      const isLimit5 = file.size / 1024 / 1024 < 25;
      // if (!isLimit5) {
      //   this.$global.error(this, "只能上传25MB以内的文件！", null);
      //   return false;
      // } else {
        // this.file_url = URL.createObjectURL(file);
        console.log(this.file_url);
        this.file_file = file;
      // }
    },
    async uploadFile() {
      if (!this.file_file) {
        this.$global.error(this, "请选择文件！", null);
        return;
      }
      this.uploadFlag = true;
      let result = await getOSSAuthFile_Api();
      let str = this.file_file.name.split(".");
      const that = this;
      console.log("au", result);
      if (result) {
        let file_name =
          result.base_path + str[0] + Date.parse(new Date()) + "." + str[1];
        this.file_url =
          "http://wupen-doc.oss-cn-shanghai.aliyuncs.com/" + file_name;
        result.oss
          .multipartUpload(file_name, this.file_file, {
            progress: function (p) {
              //p进度条的值
              that.uploadPercentage = Math.floor(p * 100);
            },
          })
          .then((res) => {
            this.uploadFlag = false;
            let upload_url = res.res.requestUrls[0].split("?")[0];
            console.log("result", res.res.requestUrls[0].split("?")[0]);
            that.$global.success(that, "文件上传成功！", null);
            this.$emit("getUploadFile", upload_url);
          })
          .catch((err) => {
            this.uploadFlag = false;
            console.log(err);
            this.$global.error(this, "文件上传失败！", null);
          });
      } else {
        this.$global.error(this, "服务器错误！", null);
        this.uploadFlag = false;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.process {
  opacity: 0;
  height: 10px;
}
.show {
  opacity: 1;
}
.file-url {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  overflow: hidden;
}

.pc-upload-file {
  width: 200px;
  height: 40px;
  margin-top: 13px;
  margin-bottom: 30px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
  border: 1px #5470c6 dashed;
  span,
  button {
    font-size: 14px;
    text-align: center;
    color: #5470c6 !important;
    background: white;
    border: none;
  }
  /deep/ .el-upload__tip {
    margin-top: -7px;
    text-align: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/componentSet/uploadFiles.vue